import React from "react";
import classNames from "classnames";
import {WORLD_CHAT_COLOR} from "utils/constants";
import closeIcon from "images/chat/ic_close.svg";
import styles from "./index.module.scss";

export default function View({
  intl,
  inputRef,
  currentValue,
  currentColor,
  MAX_LENGTH,
  getByteCount,
  onChange,
  onClickColor,
  onClickSubmit,
  onChangeChatMode,
  onClickClose,
}) {
  return (
    <div
      className={styles.world_chat_popup}
      onClick={() => onChangeChatMode(true)}
    >
      <img
        className={styles.close_btn}
        onClick={onClickClose}
        src={closeIcon}
        alt="close"
      />
      <div className={styles.wrap}>
        <p className={styles.title}>
          {intl.formatMessage({id: "ID_WORLD_CHAT_POPUP_TITLE"})}
        </p>
        <input
          ref={inputRef}
          onChange={onChange}
          placeholder={intl.formatMessage({
            id: "ID_WORLD_CHAT_POPUP_PLACEHOLDER",
          })}
          value={currentValue}
          name="message"
        />
        <span className={styles.text_length}>
          {getByteCount(currentValue)}
          <span>/{MAX_LENGTH}</span>
        </span>
      </div>
      <div className={styles.wrap}>
        <ul className={styles.colors}>
          {WORLD_CHAT_COLOR.map(color => (
            <li
              key={color}
              className={classNames(color === currentColor && styles.active)}
              style={{background: color}}
              onClick={() => onClickColor(color)}
            />
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={onClickSubmit}
        className={classNames(
          styles.confirm_btn,
          currentValue.trim().length !== 0 && currentColor && styles.active,
        )}
      >
        {intl.formatMessage({id: "ID_WORLD_CHAT_POPUP_CONFIRM"})}
      </button>
    </div>
  );
}
